import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface useDeleteBannerParams {
  id: number | null | undefined
}

interface useDeleteBannerProps {
  onSuccess?: (data: undefined, variables: useDeleteBannerParams) => void
  onError?: (error: Error, variables: useDeleteBannerParams) => void
}

export const useDeleteSystemBannerById = ({
  onSuccess,
  onError,
}: useDeleteBannerProps) => {
  const deleteBanner = useTypedApiClient({
    path: '/admin/system-banners/{id}',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, useDeleteBannerParams>({
    mutationFn: async ({ id }: useDeleteBannerParams) => {
      await deleteBanner({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/system-banners'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
